import { ReviewStats } from './stats'
import React from 'react'
import Alert from '../../components/alert'
import { ActionRecord } from '../../lib/types'

type Props = {
    stats: ReviewStats
    action?: ActionRecord
    actionName: string
}

export default function StatsInfo(props: Props) {
    const { stats, action, actionName } = props

    return (
        <Alert>
            <div className='flex'>
                <div className='font-bold w-1/3'>Last {actionName}:</div>
                <div>{action ? new Date(action.actionTime).toLocaleString() : <em>Never</em>}</div>
            </div>
            <div className='flex'>
                <div className='font-bold w-1/3'>Reviewed:</div>
                <div>
                    {stats.approvals} / {stats.total} ({stats.approvalsPct}%)
                </div>
            </div>
            <div className='flex'>
                <div className='w-1/3 pl-4'>by you:</div>
                <div>
                    {stats.yourApprovals} / {stats.total} ({stats.yourApprovalsPct}%)
                </div>
            </div>
        </Alert>
    )
}
